import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import {
  AtosBoletimService
} from "../../../services/AtosBoletimService";

export default {
  name: "EditarAto",

  components: {
    FormDialog,
    TextField,
  },

  props: {
    id: {
      required: true
    },
    isOpen: {
      required: true

    }

  },

  data: () => ({

    form: {},
    loading: {
      button: false
    }
  }),

  beforeMount() {
    this.initializeForm();

  },
  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.initializeForm();
      }
    },
  },


  methods: {
    initializeForm() {
      this.form = {
        ondeLe: null,
        leiaSe: null,
        justificativa: null,
      };
    },

    prepareForm() {
      if (this.form.ondeLe != null && this.form.leiaSe != null && this.form.justificativa != null) {

        const form = new FormData();
        form.append('ondeLe', this.form.ondeLe);
        form.append('leiaSe', this.form.leiaSe);
        form.append('justificativa', this.form.justificativa);

        return this.sendForm(form);
      }
      SnackBarModule('Preencha todos os campos', 'error')
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await AtosBoletimService.editarAto(formData, this.id);
      this.loading.btn = false;
      if (response) {
        this.initializeForm();
        this.close();
      }
      this.loading.btn = false;
    },

    close() {
      this.$emit("on-close");
      this.initializeForm();

    },

  },
};
1